<template>
  <main class="content">
    <Hero title="Wachtwoord vergeten"/>
    <main class="main block maxw--neck">
      <p class="text--center mb-2">
        Indien je uw wachtwoord bent vergeten kun je hier jouw e-mail invullen. Indien deze in het systeem bekend is
        zal je een bericht ontvangen met daarin de link om uw wachtwoord opnieuw in te stellen.
      </p>
      <form class="form" @submit.prevent="submit">
        <fieldset class="form__fieldset">
          <div class="form__row">
            <FormTextField class="field" name="email" type="email" label="Email" v-model="v$.email.$model" :validator="v$.email"/>
          </div>
          <div class="form__row">
            <div class="field">
              <button class="btn btn--full mt-2" type="submit" :disabled="isLoading">
                Verzenden
                <Spinner v-if="isLoading" />
              </button>
            </div>
          </div>
          <div class="form__row" v-if="!neutral">
            <span class="field__status text--center" :class="feedbackClass">{{ feedbackMessage }}</span>
          </div>
        </fieldset>
      </form>
      <div class="vertical-center mt-2">
        <nuxt-link to="/" class="btn btn--flat">Terug naar homepagina</nuxt-link>
      </div>
    </main>
  </main>
</template>

<script lang="ts" setup>
import type { Strapi4Error } from '@nuxtjs/strapi/dist/runtime/types';
import useVuelidate from '@vuelidate/core';
import { email as emailValidator, helpers, required } from '@vuelidate/validators';

useHead({
  title: 'Wachtwoord vergeten'
});

const { forgotPassword } = useStrapiAuth();
const { isLoading, startLoading, stopLoading } = useLoading();
const { feedbackMessage, resetStatus, setStatus, handleSuccess, neutral, feedbackClass } = useSubmitFeedback(
  'Email verzonden indien bekend',
  'Er is iets fout gegaan. Probeer het later opnieuw'
);

const email = ref('');

async function submit(e: Event) {
  resetStatus();

  if (!(await v$.value.$validate()) || isLoading.value) return;

  startLoading();

  try {
    await forgotPassword({ email: email.value });

    handleSuccess();
  } catch (e) {
    const error = e as Strapi4Error;

    if (error?.error?.name === 'ValidationError') {
      setStatus(true);
    } else {
      setStatus(false);
    }
  } finally {
    stopLoading();
  }
}

const rules = computed(() => ({
  email: {
    required: helpers.withMessage('Dit veld is verplicht.', required),
    email: helpers.withMessage('Je dient een geldig emailadres in te vullen.', emailValidator)
  },
}));

const v$ = useVuelidate(rules, { email });

definePageMeta({
  pageTransition: pageTransitionConfig,
});
</script>
